module.exports = __webpack_public_path__ + "img/light_line.09d5b753.png";